
export const MAX_UPLOAD_MB = 300;

export const PERMITTED_EXTENSIONS = [
  'PDF',
  'XLS',
  'XLSX',
  'DOC',
  'DOCX',
  'PPT',
  'PPTX',
  'PPS',
  'PPSX',
  'TXT',
  'CSV',
  'DWG',
  'DWF',
  'FDR',
  'GIF',
  'PNG',
  'JPG',
  'JPEG',
  'TIF',
  'TIFF',
  'TGA',
  'BMP',
  'MP4',
  'MPG',
  'MOV',
  'MPP',
  'MPX',
  'VSD',
  'VSDX ',
];

export const PERMITTED_EXTENSIONS_RFS = [
  'PDF',
  'XLS',
  'XLSX',
  'DOC',
  'DOCX',
  'PPT',
  'PPTX',
  'PPS',
  'PPSX',
  'TXT',
  'CSV',
];

export const MAX_UPLOAD_MB_RFS = 50;
